import React, { useState } from "react";

const AuthContext = React.createContext({
    token: localStorage.getItem("token"),
    loginData : localStorage.getItem("loginData"),
    isLoggedIn: false,
    login: (token) => { },
    logout: () => { }
});

export const AuthContextProvider = (props) => {
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [loginData, setLoginData] = useState(localStorage.getItem('loginData'));
    const userIsLoggedIn = !!token;

    const loginHandler = (token, loginData) => {
        localStorage.setItem("token", token);
        localStorage.setItem("loginData", JSON.stringify(loginData));;
        setToken(token);
        setLoginData(JSON.stringify(loginData))
    }

    const logoutHandler = () => {
        setToken(null);
        setLoginData('');
        localStorage.removeItem("token");
        localStorage.removeItem("loginData");
    }
    const contextValue = {
        token: token,
        loginData : loginData,
        isLoggedIn: userIsLoggedIn,
        login: loginHandler,
        logout: logoutHandler
    }

    return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>
}

export default AuthContext;